import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Requests from "../../pages/services/Requests";

const YearlyStats = () => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "area",
      stacked: false,
      height: "100%",
      width: "100%",
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 2,
      curve: "smooth"
    },
    series: [
      {
        name: "Appointments",
        data: []
      }
    ],
    xaxis: {
      categories: [],
      labels: {
        style: {
          colors: "#6b7280",
          fontSize: "12px",
          fontFamily: "Arial, sans-serif"
        }
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: "#6b7280",
          fontSize: "12px",
          fontFamily: "Arial, sans-serif"
        }
      }
    },
    colors: ["#c70e2a"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 90, 100]
      }
    },
    grid: {
      show: true,
      borderColor: "#ebebeb",
      strokeDashArray: 2,
      position: "back"
    },
    markers: {
      size: 4,
      strokeWidth: 2,
      hover: {
        size: 6
      }
    },
    tooltip: {
      enabled: true,
      theme: "dark",
      style: {
        fontSize: "12px"
      },
      y: {
        formatter: function (val) {
          return val + " appointments";
        }
      }
    }
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await Requests.getDashboardStats();

        if (response.data.success && response.data.data.yearly_stats) {
          const yearlyData = response.data.data.yearly_stats;

          // Sort data by year (ascending)
          yearlyData.sort((a, b) => parseInt(a.year) - parseInt(b.year));

          setChartOptions(prev => ({
            ...prev,
            series: [{
              name: "Appointments",
              data: yearlyData.map(item => item.appointments)
            }],
            xaxis: {
              ...prev.xaxis,
              categories: yearlyData.map(item => item.year)
            }
          }));
        }
      } catch (err) {
        console.error("Error fetching dashboard stats:", err);
        setError("Failed to load yearly statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        {error}
      </div>
    );
  }

  return (
    <div style={{ height: "300px" }}>
      <ReactApexChart
        options={chartOptions}
        series={chartOptions.series}
        type="area"
        height="100%"
      />
    </div>
  );
};

export default YearlyStats;